exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#action_action2.keyboard-focused:not(input){outline:3px solid #80e6ff}.registration-dialog>.close-btn,.hidden-focused{outline:none}.registration-dialog>.close-btn.keyboard-focused,.keyboard-focused:not(input){outline:3px solid #f7c60f}\n", ""]);

